export default "__VITE_ASSET__BO64$lbr__"